import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import EventBrellaLayout from './EventBrellaLayout';
import { useTalkToUs } from './TalkToUsPopup';

const EventBrellaRoiInner = () => {
  const { scheduleTalkToUsFromRoi } = useTalkToUs();

  useEffect(() => {
    scheduleTalkToUsFromRoi();
  }, [scheduleTalkToUsFromRoi]);

  return (
    <section className="ledger-section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">The Math</span>
          <h2>Lower fees. Higher margin. Same door.</h2>
        </div>
        <div className="ledger-card">
          <div className="ledger-head">
            <span className="tag a">Line Item</span>
            <div style={{ display: 'flex', gap: 60 }}>
              <span className="tag a">Outdated ticketing platforms</span>
              <span className="tag b">EventBrella</span>
            </div>
          </div>
          <div className="ledger-row">
            <div className="label">
              Platform + processing fees
              <small>Passed to host and guest</small>
            </div>
            <div className="val eb-old">~10–12%</div>
            <div className="val eb-new">~5–6%</div>
          </div>
          <div className="ledger-row">
            <div className="label">
              Guest contact data
              <small>Email, phone, order history</small>
            </div>
            <div className="val eb-old">Held by platform</div>
            <div className="val eb-new">Owned by host</div>
          </div>
          <div className="ledger-row">
            <div className="label">
              Table &amp; parking reservations
              <small>Bundled at checkout</small>
            </div>
            <div className="val eb-old">Separate tool</div>
            <div className="val eb-new">One QR code</div>
          </div>
          <div className="ledger-row">
            <div className="label">
              Returning guest recognition
              <small>Staff sees usual order &amp; preferences</small>
            </div>
            <div className="val eb-old">None</div>
            <div className="val eb-new">Built in</div>
          </div>
          <div className="ledger-foot">
            <span>Fees you keep compound. So does the audience.</span>
            <strong>~50% lower fees, host and guest side</strong>
          </div>
        </div>
        <div className="ledger-cta">
          <Link to="/calculator/events" className="btn btn-gold">Open the Calculator</Link>
        </div>
      </div>
    </section>
  );
};

const EventBrellaRoi = () => (
  <EventBrellaLayout>
    <EventBrellaRoiInner />
  </EventBrellaLayout>
);

export default EventBrellaRoi;
